import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LandingClientService } from "src/app/common/services/landing-page.client";
import { StorageService } from "src/app/common/services/storage.service";
import { SubAcuteManagementDetails } from "src/app/common/interfaces/home/subacute-management-details.interface";
import { MatTooltipModule } from "@angular/material/tooltip";
import { distinctUntilChanged, Subscription } from "rxjs";

@Component({
  selector: "app-subacute-management",
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: "./subacute-management.component.html",
  styleUrls: ["./subacute-management.component.scss"],
})
export class SubacuteManagementComponent implements OnInit {
  numberValue = 99;
  displayedNumber: string = "";
  isTooltipVisible = false;
  subAcuteDetails?: SubAcuteManagementDetails;
  private facilitySubscription: Subscription | null = null;
  constructor(
    private landingClientService: LandingClientService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.facilitySubscription =
      this.storageService.isSelectedFacility
      .pipe(
        distinctUntilChanged(),
      ).subscribe((facilityId) => {
        this.getSubacuteManagementDetails(facilityId);
      });
  }

  ngOnDestroy() {
    this.facilitySubscription?.unsubscribe();
  }

  getSubacuteManagementDetails(facilityId: string): void {
    this.landingClientService
      .getSubacuteManagementDetails(facilityId)
      .subscribe({
        next: (data) => (this.subAcuteDetails = data),
        error: (err) =>
          console.error("Error fetching subacute management details", err),
      });
  }

  showTooltip(value: number): void {
    this.numberValue = value;
    this.isTooltipVisible = true;
  }

  hideTooltip(): void {
    this.isTooltipVisible = false;
  }
}
